<template>
  <b-modal
    id="modal-payment-preview"
    hide-header
    hide-footer
    centered
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    modal-class="preview-modal"
  >
    <div class="preview-wrapper">
      <!-- Header -->
      <div class="preview-header">
        <div class="preview-header__left">
          <div class="preview-icon">
            <feather-icon icon="FileTextIcon" size="18" class="text-primary" />
          </div>
          <div>
            <h6 class="preview-title mb-0">Konfirmasi Pembayaran</h6>
            <small class="text-muted">Apakah anda yakin ingin melakukan pembayaran berikut ?</small>
          </div>
        </div>
        <button class="preview-close-btn" @click="$bvModal.hide('modal-payment-preview')">
          <feather-icon icon="XIcon" size="18" />
        </button>
      </div>

      <!-- Summary badge -->
      <div class="preview-summary">
        <span class="summary-badge">
          <feather-icon icon="CheckSquareIcon" size="13" class="mr-1" />
          {{ itemList.length }} Tagihan Dipilih
        </span>
        <span class="summary-total">
          Total: <strong>{{ formatAmountWithDecimal(total + totalVoucher) }}</strong>
        </span>
      </div>

      <!-- Table -->
      <div class="preview-table-wrap">
        <table class="preview-table">
          <thead>
            <tr>
              <th class="col-no">#</th>
              <th class="col-po">No. PO</th>
              <th class="col-branch">Cabang</th>
              <th class="col-due">Jatuh Tempo</th>
              <th class="col-unpaid">Nilai Utang</th>
              <th class="col-amount">Bayar (Rp)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemList" :key="item.uuid" class="preview-row">
              <td class="col-no text-muted">{{ index + 1 }}</td>
              <td class="col-po">
                <span
                  class="po-link"
                  role="button"
                  @click="handlePoClick(item)"
                >
                  {{ item.no_po || '-' }}
                </span>
              </td>
              <td class="col-branch">{{ item.branch || '-' }}</td>
              <td class="col-due">
                <span v-if="item.due_date" class="due-text">{{ item.due_date }}</span>
                <span v-else class="text-muted">-</span>
              </td>
              <td class="col-unpaid">
                <span class="unpaid-amount">{{ formatAmountWithDecimal(item.unpaid) }}</span>
              </td>
              <td class="col-amount">
                <span class="pay-amount">{{ formatAmountWithDecimal(parseItemAmount(item.amount)) }}</span>
              </td>
            </tr>
            <tr v-if="itemList.length === 0">
              <td colspan="6" class="text-center text-muted py-3">Tidak ada tagihan dipilih</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Divider -->
      <div class="preview-divider" />

      <!-- Total row -->
      <div class="preview-total-row">
        <span class="total-label">Total Pembayaran</span>
        <span class="total-value">{{ formatAmountWithDecimal(total + totalVoucher) }}</span>
      </div>

      <!-- Actions -->
      <div class="preview-actions">
        <button class="btn-preview-confirm" :disabled="itemList.length === 0" @click="$emit('confirm')">
          <feather-icon icon="CreditCardIcon" size="14" class="mr-1" />
          Ya, Lanjutkan Pembayaran
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  name: 'PaymentPreview',
  components: { BModal },
  props: {
    selectedItems: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
    totalVoucher: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    itemList() {
      return Object.values(this.selectedItems || {})
    },
  },
  methods: {
    formatAmountWithDecimal(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 10,
      }).format(Number(value) || 0)
    },
    parseItemAmount(raw) {
      if (typeof raw === 'number') return raw
      if (typeof raw === 'string') {
        // Handle cleave-style "1.234.567,89" → parse properly
        const cleaned = raw.replace(/\./g, '').replace(',', '.')
        const num = parseFloat(cleaned)
        return isNaN(num) ? 0 : num
      }
      return 0
    },
    handlePoClick(item) {
      if (item.uuid_po) {
        this.$emit('detail-po', item.uuid_po, item.is_stock_on_supplier)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.preview-wrapper {
  padding: 0;
  font-family: inherit;
}

/* Header */
.preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f0f0f5;

  &__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.preview-icon {
  width: 36px;
  height: 36px;
  background: rgba(115, 103, 240, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-title {
  font-size: 15px;
  font-weight: 700;
  color: #3d3d4e;
}

.preview-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #adb5bd;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f4f4f8;
    color: #6e6b7b;
  }
}

/* Summary */
.preview-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: #f8f8fc;
  border-bottom: 1px solid #f0f0f5;
}

.summary-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(115, 103, 240, 0.1);
  color: #7367f0;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.summary-total {
  font-size: 13px;
  color: #6e6b7b;

  strong {
    color: #28c76f;
    font-weight: 700;
  }
}

/* Table */
.preview-table-wrap {
  overflow-x: auto;
  max-height: 42vh;
  overflow-y: auto;
  padding: 0 4px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track { background: #f8f8fc; }
  &::-webkit-scrollbar-thumb {
    background: #d0d0da;
    border-radius: 3px;
  }
}

.preview-table {
  width: 100%;
  border-collapse: collapse;

  thead tr {
    background: #f8f8fc;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #adb5bd;
    padding: 10px 12px;
    border-bottom: 1.5px solid #edeef2;
    white-space: nowrap;
    text-align: left;
  }

  td {
    font-size: 13px;
    color: #3d3d4e;
    padding: 9px 12px;
    border-bottom: 1px solid #f5f5f8;
    vertical-align: middle;
  }
}

.preview-row {
  transition: background 0.1s;

  &:hover {
    background: #fafafe;
  }

  &:last-child td {
    border-bottom: none;
  }
}

/* Column widths */
.col-no      { width: 32px; text-align: center; }
.col-po      { min-width: 100px; }
.col-branch  { min-width: 90px; }
.col-due     { min-width: 110px; }
.col-unpaid  { min-width: 120px; text-align: right; }
.col-amount  { min-width: 120px; text-align: right; }

.po-link {
  color: #004ad7;
  cursor: pointer;
  font-weight: 600;
  transition: opacity 0.15s;

  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
}

.unpaid-amount {
  color: #ea5455;
  font-weight: 600;
}

.pay-amount {
  color: #28a745;
  font-weight: 700;
}

.due-text {
  font-size: 12px;
  color: #6e6b7b;
}

/* Divider */
.preview-divider {
  height: 1px;
  background: #f0f0f5;
  margin: 0 20px;
}

/* Total row */
.preview-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f8f8fc;
  border-top: 1px solid #edeef2;
  border-bottom: 1px solid #edeef2;
}

.total-label {
  font-size: 13px;
  font-weight: 600;
  color: #6e6b7b;
}

.total-value {
  font-size: 16px;
  font-weight: 800;
  color: #28c76f;
}

/* Actions */
.preview-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
}

.btn-preview-cancel {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  background: #fff;
  color: #6e6b7b;
  border: 1.5px solid #d0d0da;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f4f4f8;
    border-color: #b0b0be;
  }
}

.btn-preview-confirm {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: linear-gradient(135deg, #28c76f, #20a75e);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(40, 199, 111, 0.28);
  transition: all 0.18s;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 5px 14px rgba(40, 199, 111, 0.38);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
}
</style>
